/**
 * Windermere Theme Configuration
 *
 * Nord Anglia / Windermere Preparatory School theme with navy color palette.
 * Uses the veneer system to overlay custom components (WindermereHeader,
 * WindermereLanding) on top of the base implementation.
 *
 * Veneer components are loaded from: src/themes/veneer/windermere/
 */

export const windermereTheme = {
  name: 'windermere',
  brandName: 'Windermere Preparatory School',
  logoPath: 'nord-anglia-school_windermere_logo_horizontal_white.png',

  // Enable veneer system for component overrides
  veneer: {
    enabled: true,
    // Components that use custom veneer versions
    components: ['LandingPage', 'AppHeader'],
  },

  colors: {
    headerColor: '#0C2340',       // Windermere brand navy
    headerHover: '#07162a',       // Darker navy for hover
    frameColor: '#1a3a5c',        // Lighter navy for frames
    buttonColor: '#0C2340',       // Navy for primary buttons (safe global default)
    buttonHover: '#07162a',       // Darker navy for hover
    // Primary action buttons - dark navy for white text contrast
    primaryActionBg: '#0C2340',   // Brand navy - high contrast with white text
    primaryActionBgHover: '#07162a', // Darker navy for hover
    highlightButtonColor: '#BA0C2F', // Windermere brand red (replaces teal)
    highlightButtonHover: '#8a0921', // Darker red for hover
    headerButtonColor: '#FFFFFF',    // White for nav links on navy header
    textColor: '#0C2340',
    lightTextColor: '#FFFFFF',
    buttonTextColor: '#FFFFFF',
    headerTextColor: '#FFFFFF',
    headerButtonTextColor: '#FFFFFF',
    alertColor: '#E32323',
    alertHover: '#c21e1e',
    successColor: '#699864',
    successHover: '#527a4d',
    inactiveColor: '#C3C3C3'
  },

  components: {
    header: 'WindermereHeader',
    hero: 'WindermereHero',
    landing: 'WindermereLanding',
    footer: 'GenericFooter'
  },

  features: {
    megaMenu: true,
    searchBar: true,
    scrollEffects: true,
    heroSection: true,
    quickActions: true,
    shopByGrade: true,
    shopByCollection: true,
    contactInMenu: true,
    instagramLink: true,
    promoBanner: true,
  },

  contact: {
    email: 'campus.store@windermereprep.com',
    phone: '(407) 905-7737',
    address: '6189 Winter Garden-Vineland Road, Windermere, FL 34786',
    instagram: 'https://instagram.com/windermereprep',
    website: 'https://www.windermereprep.com',
  },

  branding: {
    tagline: 'Part of the Nord Anglia Education family',
    heroTitle: 'WINDERMERE E-COMMERCE STORE',
    heroSubtitle: 'WELCOME TO',
    heroDescription: 'Windermere Preparatory School is the leading international prep school in Orlando and part of the worldwide Nord Anglia family of premium international schools.',
    heroImage: '/images/campus-store.png'
  }
}
